import { Button, PersonAddAltOutlinedIcon, Text } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { AddReviewerModal } from '../add-reviewer-modal';

interface AddReviewerButtonProps {
  excludeUserIds?: string[];
  qsetId: string;
}

export default function AddReviewerButton(props: Readonly<AddReviewerButtonProps>) {
  const { excludeUserIds = [], qsetId } = props;
  const [isAddReviewerOpen, { open: openAddReviewer, close: closeAddReviewer }] =
    useDisclosure(false);

  return (
    <>
      <Button
        variant='outlined'
        onClick={(e) => {
          e.stopPropagation();
          openAddReviewer();
        }}
        sx={(theme) => ({
          py: theme.spacing(1.5),
          px: theme.spacing(3),
          borderColor: theme.palette.grey[300],
          alignItems: 'center',
          gap: theme.spacing(1.5),
          height: 'fit-content',
        })}
      >
        <PersonAddAltOutlinedIcon
          sx={(theme) => ({ height: theme.spacing(5), width: theme.spacing(5) })}
        />
        <Text variant='body2Semibold' sx={(theme) => ({ lineHeight: theme.spacing(5) })}>
          Add Reviewer
        </Text>
      </Button>

      <AddReviewerModal
        open={isAddReviewerOpen}
        onClose={closeAddReviewer}
        excludeUserIds={excludeUserIds}
        qsetId={qsetId}
      />
    </>
  );
}
